import { Sensible } from './sensible';

export default async () => {
  (window as unknown as Window & { Sensible: Sensible }).Sensible =
    new Sensible();
};
